// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"17":"20112940","42":"1674798e","55":"9b85912e","225":"c0f5bd6e","257":"bf9af8d7","272":"082b7842","637":"6dc71f81","778":"34a640d0","896":"5ced045a"}[chunkId] + ".js";
};